import { Verbiage } from './DisplayLanguage';
import { TimeRange } from '../Models/Enums/TimeRange';
import { Referrer } from '../Models/Enums/Referrer';
import { MilitaryBranch } from './Enums/MilitaryBranch';
import { EmployeeLookup } from './EmployeeLookup';

export class DennysFlow{
    constructor(){ }

    ReceivedTANF : boolean;
    ReceivedSNAP : boolean;
    ReceivedSSI : boolean;
    DoesNotApply : boolean;
    TANFPayments : InputRange;
    SNAPPayments : InputRange;
    AgeRangeValid : boolean;
    Unemployed : boolean;
    WeeksUnemployed : number;
    WeeksUnemployedAndCompensated : number;
    MilitaryService : boolean;
    Discharged : boolean;
    EntitledToCompensation: boolean;
    VocationalRehab : boolean;
    FelonyConviction : boolean;
    CurrentCategory : WOTCCategory;
}

export class Question {
    Get() :any{};
    Set(val:any): any{};
    Answered : boolean;
    Answer : any;
    dennys : DennysFlow;
    // public get answer() : any {
    //     return this.Property;
    // }

    // public set answer(v : any) {
    //     this.Property = v;
    // }
    
    Name: string;
    show():boolean{return false;};
    Category: WOTCCategory;
    Verbiage: Verbiage[];
}

export enum WOTCCategory {
    TANF = 0,
    SNAP = 1,
    UNEMPLOYMENT = 2,
    MILITARY = 3,
    VOCATIONALREHAB = 4,
    FELON = 5,
    SSI = 6
}

export enum InputRange {
    Low = 0,
    Mid = 1,
    High = 2
}


// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/Models/dennysFlow.ts